import { FunctionComponent } from "react";

import { useFormatDate } from "../../../../../../utils/hooks/formatDateHook";

import "./ExchangeUserMetaDataInformation.scss";

import { ChatExchangeModel } from "../../../../../../@api";

interface IExchangeUserMetaDataInformationProps {
  exchange: ChatExchangeModel;
}

export const ExchangeUserMetaDataInformation: FunctionComponent<IExchangeUserMetaDataInformationProps> = (
  props: IExchangeUserMetaDataInformationProps,
) => {
  const formatDate = useFormatDate();

  return (
    <div className="exchange-user-meta-data-information">
      {!!props.exchange.askedOn && <small className="message-date-time">{formatDate(props.exchange.askedOn)}</small>}
    </div>
  );
};
